export const SET_SETUP_TYPE = "SET_SETUP_TYPE";

export function changeSetupType(store) {
  store.on("@init", () => {
    const temp = localStorage.getItem("setupType");
    const res = temp && temp !== "undefined" ? JSON.parse(temp) : "By Lane";
    return { setupType: res };
  });

  store.on(SET_SETUP_TYPE, ({ setupType }, type) => {
    localStorage.setItem("setupType", JSON.stringify(type));
    return { setupType: type };
  });
}
